<div class="app-marketplace-card-main">
  @if (advert) {
    <div
      class="marketplace-card"
      [class.is-vip]="advert.user.isVip"
      (click)="onClickToPrepopulate($event, advert)">
      @if (advert.user.isVip) {
        <div class="vip-badge" (click)="onClickToPrepopulate($event, advert)">
          <img alt="vip-badge" src="/assets/images/svg/vip-badge-bg.svg" />
          <div class="vip-text">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_161_1104)">
                <path
                  d="M9.50661 19.5324L6.55486 13.4522L8.28948 11.9377L11.7332 20.2563L10.6121 21.2351L9.50661 19.5324ZM4.00369 15.6796L9.6302 19.4245L11.1771 20.7419L10.0428 21.7323L2.2779 17.1864L4.00369 15.6796ZM10.7847 9.75907L16.3957 16.1856L14.8509 17.5343L9.23992 11.1079L10.7847 9.75907ZM18.5232 10.4855L16.9254 11.8805L15.8811 10.6843L17.4789 9.28932C17.6966 9.09921 17.8411 8.90828 17.9122 8.71654C17.9833 8.52479 17.9933 8.33721 17.942 8.15379C17.8911 7.96485 17.7938 7.788 17.6499 7.62322C17.4958 7.44666 17.3208 7.31161 17.125 7.21807C16.9322 7.12195 16.7283 7.08737 16.5133 7.11433C16.2958 7.13835 16.0781 7.24541 15.8603 7.43553L14.8452 8.32187L19.4118 13.5522L17.8625 14.9048L12.2516 8.47837L14.816 6.23939C15.3309 5.7898 15.856 5.49731 16.3912 5.36192C16.9293 5.22397 17.4423 5.23242 17.9301 5.38728C18.4154 5.5392 18.8417 5.82555 19.2091 6.24634C19.5713 6.66123 19.7873 7.11051 19.857 7.59418C19.9266 8.07784 19.8504 8.56962 19.6283 9.0695C19.4065 9.56388 19.0382 10.0359 18.5232 10.4855Z"
                  fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_161_1104">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      }
      <div
        class="mk-qv"
        (click)="openComponentDialog($event, advert.shortId.toString())"
        role="button"
        aria-label="open quick view dialog">
        <img alt="question-mark" src="/assets/images/svg/question.svg" />
      </div>
      <div class="marketplace-card-img">
        <img
          [src]="advertImage"
          [alt]="
            'Escort Profile Image - ' +
            (truncateAdvertName(name) || 'Advertisement')
          "
          (error)="onImageError($event)" />
      </div>
      <div class="marketplace-card-body1"></div>
      <div class="marketplace-card-body">
        <h3>
          <span>{{ truncateAdvertName(name) }} </span>
          @if (advert.user.isVerfied) {
            <span>
              <img src="./assets/images/svg/verified.svg" alt="verified" />
            </span>
          }
        </h3>
        <h3>
          @if (!advert.zone?.name) {
            <span>{{ advert.area?.name || advert.division?.name }},</span>
          } @else {
            <span>{{ advert.zone?.name }},</span>
          }
          <span>{{ advert.age }}y</span>
        </h3>
      </div>
    </div>
  }
</div>
